angular.module('App.v1.Filters')
    .filter('recency', function () {
        return function (input) {
            //Withing 1 minute
            if (input < 60) {
                return "Seconds";
            }
            if (input >= 3600 && input < 86400) {
                return Math.floor(input / 3600) + " Hours";
            }
            if (input >= 86400) {
                return Math.floor(input / 86400) + " Days";
            }

            var minutes = Math.floor(input / 60);
            if (minutes == 1) {
                return minutes + " Minute";
            }
            return minutes + " Minutes";
        };
    });